import { useAuth } from "../../../contexts/AuthProvider"

// This hooks checks to see if the JWT is compatible with the New Platform.
// If it isn't it redirects to the logout route which will clear the
// cookies and redirect to the login page.

// This code can be removed at end of June 2022 when everyone should
// have been logged out anyway.
// @TODO - Can this be removed now????

export const useEnsureOwnerId = () => {
  const auth = useAuth()
  const user = auth.getAuthUser()

  if (user === null) {
    return
  }

  if (user.type !== `admin` && user.ownerId === null) {
    window.location.replace(`/logout`)
  }
}
